import { Grid, Icon, Paper, Typography } from '@material-ui/core';
import React from 'react';
import './Resume.css';
import resumeData from '../../Utils/resumeData'
import  TimeLineCom,{CoustorTimelineSeparator} from '../Profile/Timeline'
import WorkIcon from '@material-ui/icons/Work';
import SchoolIcon from '@material-ui/icons/School';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
const Resume = () => {
    return (
        <div>
          
    
{/*>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Work & Education  */}

            <Grid container className='section' >
                <Grid item className="sectionTitle mb_30" >
                    <span></span>
                    <h6  className="sectiontitle_text " >Resume</h6>
                </Grid>
                <Grid item xs={12}>
                    <Grid container >
                        {/* working History  */}
                        <Grid item sm={12} md={6}>
                                <TimeLineCom
                                    title={" Working History "}
                                    icon ={<WorkIcon />}
                                    >
                                    {
                                        resumeData.experiences.map((experience) =>(
                                            <TimelineItem>
                                                <CoustorTimelineSeparator>
                                                <TimelineSeparator className={'separator_padding'}>
                                                <TimelineDot variant="outlined" className={'timeline_dot'} />
                                                <TimelineConnector />
                                                </TimelineSeparator>
                                                </CoustorTimelineSeparator>
                                                <TimelineContent >
                                                    <Typography className="timeline_title">
                                                        {experience.title}
                                                    </Typography>
                                                    <Typography variant="caption" className="timeline_date">
                                                        {experience.date}
                                                    </Typography>
                                                    <Typography variant="body2" className="timeline_txt">
                                                        {experience.description}
                                                    </Typography>
                                                </TimelineContent>
                                            </TimelineItem>
                                        ) )
                                    }
                                </TimeLineCom>

                    </Grid>
{/*>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Experianse es  */}
                        <Grid item sm={12} md={6}>
                        <TimeLineCom
                          title={" Education  "}
                          icon={<SchoolIcon />}
                        
                        >


                    

                        {
                            resumeData.Education.map((experience) =>(
                                <TimelineItem>
                                    <CoustorTimelineSeparator>
                                    <TimelineSeparator className={'separator_padding'}>
                                    <TimelineDot variant="outlined" className={'timeline_dot'} />
                                    <TimelineConnector />
                                    </TimelineSeparator>
                                    </CoustorTimelineSeparator>
                                    <TimelineContent >
                                        <Typography className="timeline_title">
                                            {experience.title}
                                        </Typography>
                                        <Typography variant="caption" className="timeline_date">
                                            {experience.date}
                                        </Typography>
                                        <Typography variant="body2" className="timeline_txt">
                                            {experience.description}
                                        </Typography>
                                    </TimelineContent>

                                </TimelineItem>
                            ) )
                        }
</TimeLineCom>
                        </Grid>
                        
                    </Grid>
                </Grid>
                
            </Grid>
{/* >>>>>>>>>>>>>>>>>>>>> My services  */}
           <Grid container className='section' >
                <Grid item className="sectionTitle mb_30" >
                    <span></span>
                    <h6  className="sectiontitle_text " >services</h6>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={3} justify="space-around">
                        {
                            resumeData.services.map(service => (
                                <Grid  item xs={12} sm={6} md={4}>
                                    <div className="services">
                                        <Icon className="services_icon">
                                            {service.icon}
                                        </Icon>
                                        <Typography  className="service_title">
                                            {service.title}
                                        </Typography>
                                        <Typography variant="body2" className="service_txt" >
                                            {service.description}
                                        </Typography>
                                    </div>
                                </Grid>
                            ) )
                        }
                    </Grid>
                </Grid>
           </Grid>

{/*>>>>>>>>>>>>>>>>>>>>>>> Skill me  */}
                    <div  className="skill_Part">

                        
                    <Grid container className='section pb_45 gray_bg p_50' >
                    <Grid item xs={12}>
                        <Grid container justify="space-between"  spacing={3}>
                        {resumeData.skill.map(skil => (
                                    <Grid item xs={12} sm={6} md={3} className="skill" >
                                        <Paper elevation={3} >
                                            <Typography varian="h6" className="skill_title">
                                                {skil.title}
                                            </Typography>
                                            {skil.description.map( (des) => (
                                            <Typography variant="body2" className="skill_txt">
                                                <TimelineDot className="skill_dot" variant="outlined" />
                                                    <div className="skill_item">
                                                        {des}
                                                    </div>  
                                                
                                            </Typography>
                                            ))}
                                        </Paper>
                                    </Grid>
                            ))}
                        </Grid>
                    </Grid>                                      
                    </Grid>
                    </div>
        </div>
    );
};

export default Resume;